import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card } from '@/shared/components/Card';

const TableHeaderButton = ({ titleButton, onClick }) => (
  <Card>
    <HeaderWrap>
      <HeaderWrap3>
        <StyledButton onClick={onClick}>
          {titleButton}
        </StyledButton>
      </HeaderWrap3>
    </HeaderWrap>
  </Card>
);

TableHeaderButton.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    tableRowsData: PropTypes.arrayOf(PropTypes.object),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.object),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  titleButton: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

TableHeaderButton.defaultProps = {
  reactTableData: {
    tableHeaderData: [],
    tableRowsData: [],
    defaultTableHeaderData: [],
    defaultTableRowData: [],
  },
};

export default TableHeaderButton;

// region STYLES
const HeaderWrap = styled.div`
  display: flex;
  flex-direction: column;

  & > div:first-child {
    margin-right: auto;
  }
`;

const HeaderWrap3 = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  & > div:first-child {
    margin-right: auto;
  }
`;

const StyledButton = styled.button`
  background-color: #25DBA7;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 25px;
  font-size: 14px;
  margin-right: 0px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #164275;
  }

  &:active {
    background-color: #12365f;
  }
`;
// endregion
